<template>
  <div>
    <el-dialog 
      :title="title" 
      :visible="visible" 
      width="1100px" 
      @close="onClose"
      :close-on-click-modal="false"
      class="alipay-dialog"
    >
      <div class="dialog-content">
        <div class="split-layout">
          <!-- 左侧分类树 -->
          <div class="left-panel">
            <div class="tree-header">
              <i class="el-icon-folder-opened"></i>
              <span>图片分类</span>
            </div>
            <el-tree
              :data="docCateList"
              node-key="id"
              :props="defaultProps"
              default-expand-all
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              class="category-tree"
            >
              <span class="tree-node" slot-scope="{ node, data }">
                <i class="el-icon-folder"></i>
                <span>{{ node.name }}</span>
                <span class="tree-node-count" v-if="data.count">({{ data.count }})</span>
              </span>
            </el-tree>
          </div>

          <!-- 右侧内容 -->
          <div class="right-panel">
            <!-- 工具栏 -->
            <div class="toolbar">
              <el-form :inline="true" size="small">
                <el-form-item>
                  <el-input 
                    v-model="keywords" 
                    placeholder="请输入图片名称"
                    prefix-icon="el-icon-search"
                    clearable
                    class="search-input"
                    @keyup.enter.native="goSearch"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="goSearch" icon="el-icon-search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="uploadDoc" icon="el-icon-upload">上传图片</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="useSelected" icon="el-icon-picture">使用选中图片</el-button>
                </el-form-item>
              </el-form>
            </div>

            <!-- 图片表格 -->
            <div class="table-wrapper">
              <el-table
                ref="multipleTable"
                :data="mList"
                stripe
                border
                size="medium"
                :header-cell-style="headerCellStyle"
                @row-click="handleRowClick"
                v-loading="loading"
                element-loading-text="加载中..."
              >
                <el-table-column label="选择" width="60" align="center">
                  <template slot-scope="scope">
                    <el-radio 
                      v-model="selectedImage" 
                      :label="scope.row" 
                      @input="clickChange(scope.row, scope.$index)"
                    >{{ "" }}</el-radio>
                  </template>
                </el-table-column>
                
                <!-- <el-table-column label="缩略图" width="100" align="center">
                  <template slot-scope="scope">
                    <el-image
                      class="thumbnail-image"
                      :src="scope.row.url"
                      fit="cover"
                      :preview-src-list="[scope.row.url]"
                    >
                      <div slot="placeholder" class="image-placeholder">
                        <i class="el-icon-loading"></i>
                      </div>
                      <div slot="error" class="image-error">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
                </el-table-column> -->
                
                <el-table-column
                  label="文件名称"
                  min-width="250"
                  prop="name"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="file-name">
                      <i class="el-icon-document"></i>
                      <span>{{ scope.row.name }}</span>
                    </div>
                  </template>
                </el-table-column>
                
                <el-table-column
                  label="文件格式"
                  width="100"
                  prop="ext"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag size="small" type="info" effect="plain">
                      {{ scope.row.ext || '-' }}
                    </el-tag>
                  </template>
                </el-table-column>
                
                <el-table-column
                  label="文件大小"
                  width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="file-size">{{ formatFileSize(scope.row.size) }}</span>
                  </template>
                </el-table-column>
                
                <el-table-column
                  label="创建时间"
                  width="170"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="time-text">{{ timeFormat(scope.row.create_time) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 空状态 -->
            <div v-if="mList.length === 0 && !loading" class="empty-state">
              <i class="el-icon-picture-outline"></i>
              <p>暂无图片数据</p>
              <el-button type="primary" size="small" @click="uploadDoc">立即上传</el-button>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper" v-if="total > 0">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
              >
              </el-pagination>
            </div>

            <!-- 底部按钮 -->
            <div class="dialog-footer">
              <el-button size="medium" @click="close" icon="el-icon-close">取消</el-button>
              <el-button size="medium" type="primary" @click="ok" icon="el-icon-check">确定</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 上传弹框 -->
      <el-dialog 
        title="上传图片" 
        :visible.sync="isShow" 
        width="600px" 
        append-to-body
        :close-on-click-modal="false"
        custom-class="upload-dialog"
        @closed="handleUploadDialogClosed"
      >
        <div class="upload-content">
          <el-upload
            class="image-uploader"
            drag
            action="#"
            :before-upload="handleBeforeUpload"
            :on-remove="handleRemove"
            :auto-upload="false"
            :on-change="uploadFile"
            :file-list="uploadFileList"
            list-type="picture"
            multiple
            :limit="9"
            :on-exceed="handleFileExceed"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，建议尺寸 800x800，不超过2MB</div>
          </el-upload>
        </div>
        <div slot="footer" class="upload-footer">
          <el-button size="medium" @click="closeUpload">取 消</el-button>
          <el-button size="medium" type="primary" @click="goUpload" :loading="uploading">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js"
import moment from "moment"
import axios from "axios"

export default {
  name: 'eDocList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "图片选择",
    },
    closeForm: Function,
  },
  data() {
    return {
      loading: false,
      uploading: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      docCateList: [],
      isShow: false,
      index: '',
      selectedImage: null,
      id: '',
      name: '',
      url: '',
      keywords: '',
      uploadFileList: [],
      mList: [],
      pageNum: 1,
      pageSize: 8,
      total: 0,
      item: {},
      localFormData: {}
    }
  },
  mounted() {
    this.localFormData = { ...this.formData }
    this.DataList()
    this.getUploadCategoryTree()
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '13px'
      }
    },
    
    formatFileSize(bytes) {
      if (!bytes) return '-'
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    },
    
    handleFileExceed() {
      this.$message.warning('最多只能上传9张图片')
    },
    
    handleRemove(file) {
      const index = this.uploadFileList.indexOf(file)
      if (index !== -1) {
        this.uploadFileList.splice(index, 1)
      }
    },
    
    handleUploadDialogClosed() {
      this.uploadFileList = []
    },
    
    goSearch() {
      this.pageNum = 1
      this.DataList()
    },
    
    handleNodeClick(data) {
      if (data.id) {
        this.localFormData.cate_id = data.id
        this.pageNum = 1
        this.DataList()
      }
    },
    
    closeUpload() {
      this.isShow = false
      this.uploadFileList = []
    },
    
    getUploadCategoryTree() {
      const params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
      }
      this.$axios.findUploadCategoryTree(params).then((res) => {
        if (res.code == 200) {
          this.docCateList = res.data || []
        }
      })
    },
    
    goUpload() {
      this.uploading = true
      const params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        name: this.localFormData.name,
        foreign_id: this.localFormData.foreign_id,
        contract_id: this.localFormData.contract_id,
        source: this.localFormData.source,
        upload_id: this.localFormData.upload_id
      }
      
      this.$axios.uploadForeignSave(params).then((res) => {
        if (res.code == 200) {
          this.$message.success('上传成功')
          this.isShow = false
          this.uploadFileList = []
          this.pageNum = 1
          this.DataList()
        } else {
          this.$message.error(res.msg || '上传失败')
        }
        this.uploading = false
      }).catch(error => {
        this.uploading = false
        console.log(error)
        this.$message.error('上传失败')
      })
    },
    
    uploadDoc() {
      this.uploadFileList = []
      this.localFormData.name = ''
      this.localFormData.upload_id = ''
      this.isShow = true
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    onClose() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    close() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    ok() {
      if (!this.id) {
        this.$message.warning('请选择一张图片')
        return
      }
      this.$emit('eventChoose', this.id, this.name, this.url)
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    useSelected() {
      if (!this.id) {
        this.$message.warning('请先选择图片')
        return
      }
      this.ok()
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        source: this.localFormData.source,
        foreign_id: this.localFormData.foreign_id,
        contract_id: this.localFormData.contract_id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      
      if (this.keywords) {
        param.keywords = this.keywords
      }
      if (this.localFormData.cate_id) {
        param.cate_id = this.localFormData.cate_id
      }
      
      this.$axios.findUploadListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.mList = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleRowClick(row, index) {
      this.clickChange(row, index)
    },
    
    clickChange(row, index) {
      this.index = index
      this.id = row.id
      this.name = row.name
      this.url = row.url
      this.selectedImage = row
      this.item = this.mList[index]
    },
    
    async uploadFile(item) {
      console.log('uploadFile',item);
      const file = item.raw;
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        return
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return
      }
      
      const file_md5 = await this.calculateMD5(file)
      const file_sha1 = await this.calculateSHA1(file)
      
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: file.size
      }
      
      this.$axios.uploadOne(param).then(res => {
        console.log('uploadOne',res);
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.localFormData.file_url = res.data.url
          this.localFormData.upload_id = res.data.id
          this.uploadFileList.push({ name: res.data.name, url: res.data.url })
        } else {
          this.uploadToOSS(file, file.name, file.size, file.name.split('.').pop(), file_md5, file_sha1)
        }
      })
    },
    
    uploadToOSS(file, fileName, fileSize, fileExtension, file_md5, file_sha1) {
      const param = {
        access_token: sessionStorage.getItem("token"),
        company_id: sessionStorage.getItem("company_id"),
      };
      this.$axios.getAliJsonCmp(param).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const path = data.path || ''
        
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        
        this.uploadAliOss(host, request).then(fileurl => {
          const fullurl = host + '/' + fileurl
          this.localFormData.file_url = fullurl
          this.localFormData.name = file.name
          this.uploadFileList.push({ name: fileName, url: fullurl })
          
          const uploadParams = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            name: fileName,
            size: fileSize,
            ext: fileExtension,
            md5: file_md5,
            sha1: file_sha1,
            path: fileurl,
            url: fullurl,
            status: 1,
          }
          this.$axios.uploadSave(uploadParams).then(resu => {
            this.localFormData.upload_id = resu.data.id
          })
        })
      })
    },
    
    readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsBinaryString(file)
      })
    },
    
    async calculateMD5(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.MD5(words).toString()
      })
    },
    
    async calculateSHA1(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.SHA1(words).toString()
      })
    },
    
    async uploadAliOss(host, formData) {
      return new Promise((resolve, reject) => {
        axios.post(host, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          resolve(res.data.filename)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    handleBeforeUpload() {
      return false
    },
    
    get_suffix(filename) {
      const pos = filename.lastIndexOf('.')
      return pos !== -1 ? filename.substring(pos) : ''
    },
    
    Ymdhis() {
      const date = new Date()
      return '' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + 
             date.getHours() + date.getMinutes() + date.getSeconds() + 
             Math.floor(Math.random() * 9000 + 1000)
    },
    
    timeFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.localFormData = { ...this.formData }
        this.pageNum = 1
        this.keywords = ''
        this.selectedImage = null
        this.id = ''
        this.DataList()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.alipay-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    
    .el-dialog__header {
      background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
      padding: 16px 20px;
      
      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 18px;
        
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
  }
}

.dialog-content {
  padding: 0;
}

.split-layout {
  display: flex;
  min-height: 550px;
}

// 左侧面板
.left-panel {
  width: 240px;
  background: #f8f9fc;
  border-right: 1px solid #e4e7ed;
  
  .tree-header {
    padding: 16px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    gap: 8px;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 14px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
  
  .category-tree {
    padding: 8px;
    
    ::v-deep .el-tree-node__content {
      height: 36px;
      border-radius: 8px;
      
      &:hover {
        background: #e6f4ff;
      }
    }
    
    .tree-node {
      display: flex;
      align-items: center;
      gap: 6px;
      
      i {
        color: #e6a23c;
      }
      
      .tree-node-count {
        color: #8c8f98;
        font-size: 12px;
      }
    }
  }
}

// 右侧面板
.right-panel {
  flex: 1;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
}

// 工具栏
.toolbar {
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .search-input {
    width: 200px;
    
    ::v-deep .el-input__inner {
      border-radius: 20px;
    }
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  
  .el-button--success {
    background: #00b578;
    border-color: #00b578;
    border-radius: 20px;
    
    &:hover {
      background: #1acd8c;
      border-color: #1acd8c;
    }
  }
}

// 表格样式
.table-wrapper {
  flex: 1;
  min-height: 300px;
  
  ::v-deep .el-table {
    border-radius: 12px;
    overflow: hidden;
    
    th {
      background: #fafbfc !important;
    }
    
    .el-table__row {
      cursor: pointer;
      
      &:hover {
        background: #f8f9fc;
      }
    }
    
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #1677ff;
      border-color: #1677ff;
    }
  }
}

.thumbnail-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e4e7ed;
}

.file-name {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #1677ff;
  }
}

.file-size {
  font-family: monospace;
  color: #8c8f98;
}

.time-text {
  font-size: 12px;
  color: #8c8f98;
}

// 空状态
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

// 分页
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;
}

// 底部按钮
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;
  
  .el-button {
    border-radius: 20px;
    padding: 9px 24px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 上传弹框样式
.upload-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    
    .el-dialog__header {
      background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
      padding: 16px 20px;
      
      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}

.upload-content {
  padding: 20px;
  
  .image-uploader {
    ::v-deep .el-upload-dragger {
      border-radius: 12px;
      border: 2px dashed #d9d9d9;
      background: #fafbfc;
      width: 100%;
      height: 160px;
      
      &:hover {
        border-color: #1677ff;
        background: #f0f7ff;
      }
      
      .el-icon-upload {
        font-size: 48px;
        color: #1677ff;
        margin-top: 32px;
      }
    }
    
    ::v-deep .el-upload__tip {
      color: #8c8f98;
    }
  }
}

.upload-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}
</style>